module.exports = {
	"description": "Card title component",
	"methods": [],
	"props": {
		"meta": {
			"flowType": {
				"name": "string"
			},
			"required": false,
			"description": "Information displayed above the title"
		},
		"children": {
			"flowType": {
				"name": "MnrlReactNode"
			},
			"required": true,
			"description": "Title of the card"
		},
		"minor": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Displays the title in a less important style"
		},
		"subtitle": {
			"flowType": {
				"name": "MnrlReactNode"
			},
			"required": false,
			"description": "Subtitle displayed under the title"
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/Card/CardTitle.js
// module id = 1547
// module chunks = 0